<template>
  <div class="Audit">
    <div class="top">
      <van-icon size="22px" name="arrow-left" @click="back" />
      <span class="title">{{ `${$t('append_field.content_review')}（${totalNum}）` }}</span>
    </div>
    <div >
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="materiallist abcds">
        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('append_field.noMore') "
            @load="onLoad"
        >
        <div class="audit-content">
         <div  :key="index" :style="{ height:width + 'px',width: width + 'px'}"
                  class="materia-item"
                  v-for="(item,index) in materialList" @click.stop="getselevt(item.checked,index)">
              <div class="checkbox">
                <van-checkbox v-model="item.checked"></van-checkbox>
              </div>
              <van-list style="width:100%;height: 100%;">
                <img v-if="'doc' === item.type && item.suffix==='.pdf'" src="/static/images/program/pdf.png"
                     style="width: 100%;height: 100%;">
                <img v-else-if="item.type === 'doc' && (item.suffix==='.xls' || item.suffix==='.xlsx')" src="/static/images/program/xlsx.png"
                     style="width: 100%;height: 100%;">
                <img v-else-if="'audio' !== item.type"
                   :src="getUrl (item.screenshotUrl === '' ? item.videoViewUrl : item.screenshotUrl)"
                     style="width: 100%;height: 100%;">
                <img v-else="" src="/static/images/program/msic.png"
                     style="width: 100%;height: 100%;">
              </van-list>

              <div class="audit">
                <span v-if="item.auditState === -1" class="audit0">{{$t('append_field.unreviewed')}}</span>
                <!--              <span v-if="item.auditState === 0" class="audit1">{{$t('append_field.normal')}}</span>-->
                <span v-if="item.auditState === 1" class="audit2">{{$t('append_field.violating')}}</span>
                <span v-if="item.auditState === 2" class="audit3">{{$t('append_field.suspectedViolating')}}</span>
                <span class="audit-name">{{ item.name }}</span>
              </div>
            </div>
        </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="groupings">
      <div class="groupings-left">
        <van-button color="#006EFF" size="small" @click="selectAll">{{$t('append_field.select_all') }}</van-button>
        <van-button color="#006EFF" size="small" @click="onSubmit">{{$t('append_field.filter')}}</van-button>
        <van-button color="#006EFF" size="small" @click="passMaterial"> {{ $t('append_field.review') }}</van-button>
      </div>
      <van-button color="#FF5700" size="small" @click="deletes">{{$t('append_field.delete')}}</van-button>
    </div>
    <van-dialog v-model="show" :title="$t('append_field.filter')"
                show-cancel-button
                @confirm="getmaterial(type,state,1)"
                @cancel="show = false"
                class="select-groupings">
      <div class="radio-group">
        <div class="radio-group-title">{{ $t('append_field.material_type') }}</div>
        <van-radio-group v-model="type">
          <van-cell-group >
            <van-cell
                v-for="(item, index) in typeList"
                clickable
                :key="index"
                :title="item.label"
                @click="type = item.value">
              <template #right-icon>
                <van-radio :name="item.value" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
      <div class="radio-group">
        <div class="radio-group-title">{{ $t('append_field.material_status') }}</div>
        <van-radio-group v-model="state">
          <van-cell-group >
            <van-cell
                v-for="(item, index) in stateList"
                clickable
                :key="index"
                :title="item.label"
                @click="state = item.value">
              <template #right-icon>
                <van-radio :name="item.value" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {Dialog, Toast} from 'vant'
import qs from 'qs'

export default {
  name: 'addImages',
  data() {
    return {
      width: 0,
      number: 0,
      selectImg: [],
      materia: [],
      show: false,
      tabbar: [],
      materialList: [],
      allmaterialList: [],
      index: 0,
      checked: '',
      id: 1,
      show1: true,
      msg: this.$t('append_field.loadingb'),
      images: [],
      type: '', // 默认选择“全部”
      state: '0', // 默认选择“全部”
      totalNum:0,
      typeList:[
        { value: '', label: this.$t('append_field.all') },
        { value: '3', label: this.$t('append_field.control_img') },
        { value: '4', label: this.$t('append_field.audio') },
        { value: '1', label: this.$t('append_field.document') },
        { value: '5', label: this.$t('append_field.control_video') }
      ],
      stateList:[
          { value: '0', label: this.$t('append_field.all') },
          { value: '-1', label: this.$t('append_field.unreviewed') },
          { value: '1', label: this.$t('append_field.violating') },
          { value: '2', label: this.$t('append_field.suspectedViolating') }
      ],

      pageNum: 1, // Current page number
      pageSize: 30, // Number of items per page
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  mounted() {
    this.width = document.getElementsByClassName('audit-content')[0].clientWidth / 3.3
    this.selectImg = []

  },
  methods: {
    getselevt(sele, index) {
      this.materialList[index].checked = !sele
      this.$set(this.materialList, index, this.materialList[index])
      if (this.selectImg.includes(this.materialList[index])) {
        let i = this.selectImg.indexOf(this.materialList[index])
        this.selectImg.splice(i, 1)
      } else {
        this.selectImg.push(this.materialList[index])
      }

      this.number = this.selectImg.length
    },
    selectAll(){
      const allChecked = this.materialList.every(item => item.checked)
      this.materialList.forEach((item, index) => {
        item.checked = !allChecked
        this.$set(this.materialList, index, item)
        if (!allChecked && !this.selectImg.includes(item)) {
          this.selectImg.push(item)
        } else if (allChecked && this.selectImg.includes(item)) {
          let i = this.selectImg.indexOf(item)
          this.selectImg.splice(i, 1)
        }
      });
      this.number = this.selectImg.length
    },
    async deletes() {
      //把vuex里全选出来的数据存到this.clids和this.types，由于他们是应用的是同一个存储空间所以改变一个的值另一个也会改变
      this.clids = this.checkId

      let deleteObj = []

      if (this.selectImg.length < 1) {
        Toast(this.$t('append_field.selectMaterial'))
        return
      }

      for (let i = 0; i < this.selectImg.length; i++) {
        let obj = {}
        obj.id = this.selectImg[i].mtId
        obj.type = "file"
        deleteObj.push(obj)
      }
      //查询素材是否绑定了节目和文件夹是否为空;ps:只能删除空文件夹;
      // eslint-disable-next-line no-unused-vars
      Dialog.confirm({
        title: this.$t('append_field.deleteMaterial'),
        message: this.$t('append_field.confirmDeleteMaterial'),
      }).then(() => {
        this.$ajax.post('/etv/deleteMtFolderOrMaterial.json', {
          "deleteObj": deleteObj
        }).then(res => {
          if (res.data.code == 0) {
            Toast(res.data.msg)
            this.materialList = []
            this.selectImg.length = 0
            this.onRefresh()
          } else {
            Toast(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {

      })
    },//删除文件或者文件夹
    onSubmit(){
      this.show=true
    },
    passMaterial(){
      if (this.selectImg.length < 1) {
        Toast(this.$t('append_field.selectMaterial'))
        return
      }
      Dialog.confirm({
        title: this.$t('append_field.material_review'),
        message: this.$t('append_field.current_selection_requires_review'),
      }).then(() => {
        this.$ajax.post('/etv/materialAudit.json', qs.stringify({
         ids: this.selectImg.map(d=>{return d.mtId}).join(','),
          state:0
        })).then(res => {
          if (res.data.code == 0) {
            Toast(res.data.msg)
            this.materialList = []
            this.selectImg.length = 0
            this.onLoad()
          } else {
            Toast(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {

      })
    },
    back() {
      this.$router.back()
    },
    getUrl(url) {
      if (!url) {
        return '/static/images/icon_loader_failed_braseas.png'
      }
      const isHttpUrl = url.startsWith("http")
      const isMp4 = url.endsWith(".mp4")
      if (isHttpUrl) {
        // 如果是 HTTP URL 且不是 MP4 文件，直接返回 URL
        if (!isMp4) {
          return url
        }
        // 如果是 HTTP URL 且是 MP4 文件，返回错误图片
        return '/static/images/program/video_error.png'
      }
      // 如果不是 HTTP URL，拼接基础 URL 并返回
      return this.upFileUrl + url
    },
    errImg(event) {
      event.target.src = '/static/images/icon_loader_failed_braseas.png'; // 设置错误图片
    },
    onLoad() {
      if (this.materialList.length >= this.totalNum && this.pageNum !== 1) {
        this.finished = true
        this.loading = false
        return
      }
      this.loading = true;
      this.getmaterial('',0, this.pageNum)
    },
    onRefresh() {
      this.finished = false
      this.pageNum = 1
      this.materialList = []
      this.selectImg=[]
      this.onLoad()
    },
    getmaterial(type,state, pageNum) {
      this.$ajax.post('/etv/findAuditMaterial.json', qs.stringify({
        type: type,
        pageNum,
        pageSize: this.pageSize,
        state:state?state:0
      })).then(res => {
        if (res.data.code === 0) {
          this.number =0
          document.title = this.$t('append_field.material_review')
          const newItems = res.data.data.materialList
          this.totalNum = res.data.data.totalNum
          newItems.forEach(res => {
            res.checked = false
          });
          this.materialList = [...this.materialList, ...newItems]
          this.loading = false
          this.refreshing = false

          if (this.materialList.length >= this.totalNum) {
            this.finished = true
          } else {
            this.pageNum++
          }
        } else {
          this.loading = false
          this.refreshing = false

        }
      }).catch(() => {
        this.loading = false
        this.refreshing = false

      });
    },
  },
  destroyed() {
    this.materialList = []
  },

}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.Audit {
  height: 100% !important;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 55;
  background: #ffffff;
  .top{
    padding:18px 10px;
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    justify-content: center; /* 水平居中对齐 */
    position: relative; /* 使子元素可以相对于父元素定位 */
    border-bottom: #8c8c8c 1px solid;

    .van-icon {
      position: absolute; /* 绝对定位 */
      left: 10px; /* 根据需要调整左边距 */
    }
    .title{
      font-size: 18px;
      font-size: 18px;
      float: none; /* 确保不使用浮动 */
      display: inline-block; /* 使元素成为行内块级元素 */
    }
  }
  .van-overlay{
    z-index: 99;
  }
  .full-name{
    margin: 0 10px;
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    height: 30px;
    line-height: 30px;
    span{
      width: 100%;
      display: block;
      white-space: nowrap; /* 确保文本在一行显示 */
      overflow: hidden; /* 超出容器部分隐藏 */
      text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
      font-size: 14px;
      color: #333;
    }
  }
  .materiallist {
    height: calc(100% - 60px - 62px);
    width: 100%;
    padding: 2px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 62px;
    bottom: 127px;
    overflow: auto;
    .audit-content {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;

    }
    .custom-image{
      width: 100%;
      height: 100%;
      margin-top:50%;
    }
    .custom-image .van-empty__image {
      width: 50%;
      height: 50%;
    }
    .photo {
      box-sizing: border-box;
      padding: 2px;



    }

    .materia-item {
      position: relative;
      box-sizing: border-box;
      margin: 12px 5px;
      .checkbox {
        position: absolute;
        top: 1px;
        right: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;

        checkbox {
          width: 25.42px;
          height: 25.42px;
        }
      }

      .image {
        width: 100%;
        height: 100%;
      }
    }
  }

  .groupings {
    display: -webkit-box;
    overflow-x: auto;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    height: 60px;
    align-items: center;
    padding:0 20px;
    box-sizing: border-box;
    border-top: 1px solid $uni-border-bottom-color;
    .groupings-left{
      .van-button{
        margin-right: 10px;
      }
    }

    .arrows {
      height: 20px;
      width: 20px;
    }
  }
  .van-dialog__content{
    padding:10px 20px;
    .radio-group{
      color: black;
      margin-bottom: 10px;
      .van-radio{
        margin: 5px;
        display: flex;
      }
      .van-cell__title{
        display: flex;
        align-items: center;
      }
      .van-cell{
        padding: 0 !important;
      }
    }
  }
  .van-cell__title{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .van-icon{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .van-sidebar {
    width: 100%;
    overflow-y: auto; /* 允许垂直方向滚动 */
    height: 100%; /* 高度设置为100%，或者一个固定的值 */
  }
}


.auditContent {
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.audit{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  font-size:  15px;
  white-space: nowrap;
  color: #ffffff;
  .audit0,
  .audit1{
    @extend .auditContent;
    background: rgba(0, 160, 233, 0.61);
  }
  .audit2{
    @extend .auditContent;
    background: rgba(241, 55, 61, 0.79);
  }
  .audit3{
    @extend .auditContent;
    background: rgba(241, 55, 61, 0.79);
  }
  .audit-name{
    display: inline-block;
    white-space: nowrap; /* 确保文本在一行显示 */
    overflow: hidden; /* 超出容器部分隐藏 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    width: 100%;
    line-height: 22px; /* 设置与高度相同的行高 */
    font-size: 16px;
    color: #131212;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
